export default "__VITE_ASSET__T9i9Qpu3__"